<template>
  <modal
    height="200"
    :width="width"
    name="redirect-modal"
    transition="pop-out"
    @before-open="beforeOpen" class="redirect-modal">
    <div class="redirect-modal-body">
       <div>
            <p> {{ data.title }} detayları için yönlendiriliyorsunuz</p>
        <br>
       <div class="text-center">
           <i class="fas fa-spin fa-spinner"></i>
       </div>
       </div>
    </div>
  </modal>
</template>

<script>
export default {
  data() {
    return {
      width: 450,
      data: {}
    }
  },
  methods: {
    beforeOpen(event) {
      this.data = event.params.data
    }
  },
  created() {
    this.width = Math.min(window.innerWidth - 20, 500)
  }
}
</script>


<style lang="scss">
.redirect-modal .v--modal {border-radius: 10px !important;
  background-color: #12a96f !important;
}
.redirect-modal-body {
    height: 100%;
    width: 100%;
    font-size: 16px;

    color: #fff;
    display: flex;
    justify-content: center;
    align-items: center;
}
</style>
